import { BCMSRecord, BCMSRecordProperty } from "bcms-react";
import { RegularTransaction, CheckTransaction, PaymentTransaction, TransferTransaction, Account} from ".."
/**
* @class Transaction
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.Transaction[0];
* const transaction = new transaction(record);
* @property {NUMBER} _id - The id of the transaction
* @property {STRING} _amount - The name of the transaction
* @property {STRING} _description - The custom name for the transaction
* @property {STRING} _account - the last four of transaction
* @property {STRING} _type - represents the transaction type
* @property {NUMBER} _typeID - ID of sub type for additional information
* @property {BOOLEAN} _date - can the transaction be transferred from
* @property {STRING} _status - the status of the transaction
* @property {bcmsDate} _postedDate - days in past transaction was opened
*/
export default class Transaction extends BCMSRecord {
  _id
  _amount
  _description
  _account
  _type
  _date
  _status;  
  _postedDate
  _balance;
  _filterType;

  constructor(record) {
    super( record  ) 
  }
  /**    
  * @property id {NUMBER} - Returns the transaction for the appropriate type
  * * @example const account = Transaction.initByType("1");
  * @memberof Transaction 
  */
  static initByType(id){
    let transaction =  Transaction.initByID(id);
        switch(transaction.type){
          case "regular":
            return  RegularTransaction.initByID(id);
          case "check":
            return CheckTransaction.initByID(id);
          case "payment":        
            return PaymentTransaction.initByID(id);
          case "transfer":
            return TransferTransaction.initByID(id);        
        }       
      }


  static initByAccount(id) {
    return Transaction.initAll().filter(transaction => transaction.account ? transaction.account.id === id : false, []);
  }
}
Transaction.define({
  "recordType": "transactions",
  "recordIDProp": "id",
  "className" : "Transaction",
  "recordProperties": [
      /** 
      * @name id
      * @instance
      * @property get {NUMBER} - gets the id of the transaction
      * @property set {NUMBER} - sets the id of the transaction
      * @memberof Transaction 
      */
      BCMSRecordProperty.mapToString("id", "_id"),
      /** 
       * @name amount
       * @instance
       * @property get {bcmsCurrency} - gets the amount of the transaction
       * @property set {bcmsCurrency} - sets the amount of the transaction
       * @memberof Transaction 
       */
      BCMSRecordProperty.mapToCurrency("amount", "_amount"),
      /** 
       * @name description
       * @instance
       * @property get {STRING} - gets the description of the transaction
       * @property set {STRING} - sets the description of the transaction
       * @memberof transaction 
       */
      BCMSRecordProperty.mapToString("description", "_description"),
      /** 
      * @name account
      * @instance
      * @property get {account} - gets the account of the transaction
      * @property set {account} - sets the account of the transaction
      * @memberof Transaction 
      */
      BCMSRecordProperty.mapToClass("account", "_account",()=>Account),
      /** 
      * @name type
      * @instance
      * @property get {STRING} - gets the type of the transaction
      * @property set {STRING} - sets the type of the transaction
      * @memberof Transaction 
      */
      BCMSRecordProperty.mapToString("type", "_type"),
      /** 
       * @name typeID
       * @instance
       * @property get {STRING} - gets the typeID of the transaction
       * @property set {STRING} - sets the typeID of the transaction
       * @memberof Transaction 
       */     
      BCMSRecordProperty.mapToDate("date", "_date"),
        /** 
        * @name status
        * @instance
        * @property get {STRING} - gets the status of the transaction
        * @property set {STRING} - sets the status of the transaction
        * @memberof RegularTransaction 
        */
      BCMSRecordProperty.mapToString("status","_status"),        
      /** 
       * @name postedDate
       * @instance
       * @property get {STRING} - gets the postedDate of the transaction
       * @property set {STRING} - sets the postedDate of the transaction
       * @memberof Transaction 
       */
      BCMSRecordProperty.mapToDate("postedDate", "_postedDate"),

      /**
       * @name balance
       * @instance
       * @property get {bcmsCurrency} - get the balance of the transaction
       * @property set {bcmsCurrency} - set the balance of the transaction
       * @memberof Transaction
       */
      BCMSRecordProperty.mapToCurrency("balance", "_balance"),
      /**
       * @name filterType
       * @instance
       * @property get {STRING} - get the filterType of the transaction
       * @property set {STRING} - set the filtertype of the transaction
       * @memberof Transaction
       */
      BCMSRecordProperty.mapToString("filterType", "_filterType")
    ]
})




